import Provider from './components/Provider';
import connectAdvanced from './components/connectAdvanced';
import connect from './connect/connect';

export { Provider, connectAdvanced, connect };


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/es/index.js
// module id = 31
// module chunks = 0